import { useLocation } from "@reach/router"
import { Fragment, useEffect } from "react"

import { trackingClient } from "@trueskin-web/apis"
import {
  QuestionnaireIdUrl,
  ResetCache,
  UrlLocaleSwitcher,
  VoucherUrl,
} from "@trueskin-web/components"

import Header from "./header"

const Layout = ({ children, dataTestId, enableConfirmation }) => {
  const location = useLocation()

  useEffect(() => {
    trackingClient.trackTouchPoint(location)
  }, [location])

  return (
    <Fragment>
      <ResetCache />

      <VoucherUrl />

      <QuestionnaireIdUrl />

      <UrlLocaleSwitcher />

      <Header enableConfirmation={enableConfirmation} />

      <main data-testid={dataTestId}>
        <section>{children}</section>
      </main>
    </Fragment>
  )
}

export default Layout
